import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used as an indicator to show how many actions or items user has
 * to interact with.
 */
var BadgeComponent = /** @class */ (function (_super) {
    __extends(BadgeComponent, _super);
    function BadgeComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], BadgeComponent.prototype, "floats", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], BadgeComponent.prototype, "isTopNavigation", void 0);
    BadgeComponent = __decorate([
        Component({
            name: 'ui-badge',
        })
    ], BadgeComponent);
    return BadgeComponent;
}(Mixins(MagicConfigMixin)));

export default BadgeComponent;
